export default {
  NEW_ID: '0000000000',
  MODE_ADD_NEW: 'ADD_NEW',
  MODE_UPDATE: 'UPDATE',
};
